export default __webpack_public_path__ + "src/images/packages/simbambili-lodge/04b6132b0e10ade4888940406a978823-5.jpg";